import * as style from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

interface Props {
  percentFinished: number;
}

export class Man extends Component<Props, {}> {
  render() {
    return (
      <picture className={style.imgWrapper}>
        <source
          srcset="https://static.nrk.no/dh/module/stille-spesial/assets/Header/mann/mann-400.webp"
          type="image/webp"
        />
        <img
          className={style['header__fg-img']}
          src="https://static.nrk.no/dh/module/stille-spesial/assets/Header/mann/mann-300.png"
          alt=""
        />
      </picture>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Header/Man/index.tsx